export enum PublicationSource {
  ARTICLES,
  ADMIN_DOCS,
  OTHERS
}
